module.exports = __webpack_public_path__ + "6b7c8af51246e2f65b2b1341e8e5520a.png";